export const SELECTED_SITE = 'SET_SELECTED_DOMAIN'
export const ALL_SITES = 'ALL_SITES_LIST'
export const TENANT_CONFIGS = 'TENANTCONFIGS'
export const DRAFT_CONFIGS = 'DRAFTCONFIGS'
export const SELECTED_TENANT_CONFIGS = 'SELECTED_TENANTCONFIGS'
export const SELECTED_DRAFT_CONFIGS = 'SELECTED_DRAFTCONFIGS'
export const SELECTED_EDITIOR_PREVIEW_SIZE = 'SELECTED_EDITIOR_PREVIEW_SIZE'
export const ALL_DYNAMIC_PAGES = 'ALL_DYNAMIC_PAGES'
